import { selectFromWorkspaceListingSubscription } from '../models';
import { SubscriptionHandler } from '../utils/createSubscription';
import CreatedProjectQuery from '../queries/projects/CreatedProjectQuery';
import UpdatedProjectQuery from '../queries/projects/UpdatedProjectQuery';
import projectCountUpdatedHandler from './handlers/projectCountUpdatedHandler';

const selector = selectFromWorkspaceListingSubscription()
  .projectDeletedDto(b => b.project(p => p.id.name.deleted))
  .projectCreatedDto(b => b.project(CreatedProjectQuery))
  .projectUpdatedDto(b => b.project(UpdatedProjectQuery))
  .toString();

export default (): SubscriptionHandler => ({
  name: 'WorkspaceListingSubscription',
  selector,
  events: new Map(Object.entries({
    ProjectDeletedDto: [projectCountUpdatedHandler],
    ProjectCreatedDto: [projectCountUpdatedHandler],
  })),
  onError(error: Error) {
    console.error('WorkspaceListingSubscription Error, check if websocket client initialized', JSON.stringify(error));
  },
});
